export const LANGUAGE_CONST = "E-Mun-Lang";

export const passwordValidationPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%?&]{8,}$/;
